import { render, staticRenderFns } from "./VContextMenu.vue?vue&type=template&id=7e2d06d4&"
import script from "./VContextMenu.vue?vue&type=script&lang=ts&"
export * from "./VContextMenu.vue?vue&type=script&lang=ts&"
import style0 from "./VContextMenu.vue?vue&type=style&index=0&id=7e2d06d4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports